<template>
  <b-card no-body>
    <div v-if="loading" class="d-flex justify-content-center mb-1">
      <b-spinner
        variant="success"
        label="Spinning"
        block
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <b-row v-else>
      <b-col md="6" sm="12" class="mb-3">
        <h6>Chosen Fields</h6>
        <draggable
          class="list-group"
          :list="chosenFields"
          group="people"
          @change="log"
        >
          <div
            class="list-group-item custom-list-item"
            v-for="element in chosenFields"
            :key="element.key"
          >
            {{ element.displayValue }}
          </div>
        </draggable>
      </b-col>
      <b-col md="6" sm="12" class="mb-3">
        <h6>Field Options</h6>
        <draggable
          class="list-group"
          :list="availableFields"
          group="people"
          @change="log"
        >
          <div
            class="list-group-item custom-list-item"
            v-for="element in availableFields"
            :key="element.key"
          >
            {{ element.displayValue }}
          </div>
        </draggable>
      </b-col>
      <b-col md="12" sm="12" class="d-flex justify-content-end">
        <b-button variant="primary" class="mr-1" @click="saveConfigurations"
          >Save</b-button
        >
        <b-button variant="secondary" v-b-modal.invoice-preview
          >Preview</b-button
        >
      </b-col>
      <b-modal
        id="invoice-preview"
        ok-only
        ok-title="Ok"
        centered
        size="xl"
        title="Invoice Preview"
      >
        <InvoiceTemplate
          :custAddress="isFieldChosen('CustomerAddress')"
          :custName="isFieldChosen('CustomerName')"
          :dueDate="isFieldChosen('DueDate')"
          :invoiceDate="isFieldChosen('InvoiceDate')"
          :invoiceNo="isFieldChosen('InvoiceNumber')"
          :notes="isFieldChosen('Notes')"
          :paymentTerms="isFieldChosen('PaymentTerms')"
          :salesRep="isFieldChosen('SalesRep')"
          :taxAmount="isFieldChosen('TaxAmount')"
          :totalAmount="isFieldChosen('TotalAmount')"
          :productImage="isFieldChosen('ProductImage')"
        />
      </b-modal>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BSpinner,
  BModal,
  VBModal,
} from "bootstrap-vue";
import draggable from "vuedraggable";
import { mapActions, mapGetters } from "vuex";
import InvoiceTemplate from "./InvoiceTemplate";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    draggable,
    BButton,
    BSpinner,
    BModal,
    InvoiceTemplate,
  },
  directive: {
    "b-modal": VBModal,
  },
  data() {
    return {
      chosenFields: [],
      allFields: [],
      loading: true, // Initially true to show the spinner
    };
  },
  computed: {
    ...mapGetters("tenantModule", {
      tenantFields: "tenantFields",
    }),
    availableFields() {
      return this.allFields.filter(
        (field) => !this.chosenFields.some((chosen) => chosen.key === field.key)
      );
    },
  },
  methods: {
    ...mapActions("tenantModule", [
      "getTenantFCByModuleAction",
      "updateTenantFCAction",
    ]),
    // Check if a specific field is chosen
    isFieldChosen(key) {
      return this.chosenFields.some((field) => field.key === key);
    },

    async saveConfigurations() {
      // Prepare the request body
      const requestBody = {
        moduleName: "SalesInvoice",
        configs: this.chosenFields.map((field, index) => ({
          key: field.key,
          order: index,
        })),
      };

      // Send the request via the updateTenantFCAction
      try {
        await this.updateTenantFCAction(requestBody);
        this.$swal({
          icon: "success",
          title: "Success!",
          text: "Configuration saved successfully!",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } catch (error) {
        console.error("Error saving configuration:", error);
        this.$swal({
          icon: "error",
          title: "Error!",
          text: "Failed to save configuration. Please try again.",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    },
  },
  async mounted() {
    try {
      await this.getTenantFCByModuleAction("SalesInvoice");
      // Assign the fields after the action is complete
      this.chosenFields = this.tenantFields.selectedFieldConfig;
      console.log("this.chosenFields", this.chosenFields);
      this.allFields = this.tenantFields.allFieldsConfig;
    } finally {
      // Set loading to false after fields have been assigned
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.custom-list-item {
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f8f9fa;
  border-radius: 10px;
  cursor: grab;
}
</style>
